<template>
  <div class="setPrize">
    <div class="content">
      <div class="text">
        <h6 v-html="content.prize"></h6>
        <p>{{ content.explain }}</p>
      </div>
    </div>
    <div class="closeBtn" @click="closePage()">
      <van-icon name="cross" />
    </div>
  </div>
</template>

<script>
export default {
  name: "setPrize",
  data() {
    return {
      content: {
        prize:
          "一等奖 3张单车月卡</br>（不限次）</br> 二等奖 2张单车月卡</br>（不限次）</br> 三等奖 1张单车月卡</br>（不限次）",
        explain:
          "抽中奖品后，需按照要求提交姓名+美团单车注册手机号，工作人员将在7个工作日内全部充值完毕。",
      },
    };
  },
  mounted() {},
  methods: {
    closePage() {
      this.$router.push({
        path: "/",
      });
    },
  },
};
</script>

<style lang="less" scoped>
.setPrize {
  width: 100%;
  height: 100%;
  position: relative;
  .closeBtn {
    position: absolute;
    width: 8vw;
    height: 8vw;
    font-size: 5vw;
    border: 1px solid black;
    border-radius: 4vw;
    text-align: center;
    line-height: 9vw;
    background: #ffffff;
    bottom: 10vh;
    color: black;
    left: 46vw;
  }
  .content {
    position: absolute;
    top: 15vh;
    width: 100%;
    height: 115vw;
    background-image: url("../assets/jpsz.png");
    background-size: 100% 100%;
    .text {
      width: 56%;
      margin: 35vw auto;
      text-align: center;
      display: block;
      h6 {
        margin: 0;
        padding: 0;
        font-size: 4vw;
        color: #964221;
      }
      p {
        color: #a66652;
        font-size: 3.9vw;
        text-align: left;
        font-weight: 600;
        padding-left: 3vw;
        margin: 5vw 0;
      }
    }
  }
}
</style> 



// WEBPACK FOOTER //
// src/pages/setPrize.vue